import type { ArticleType } from '@/types/ArticleType';
import decodeEntities from '@/utils/functions/string/decodeEntities';
import stripHtmlTags from '@/utils/functions/string/stripHtmlTags';

const mapWpPost = (r: any): ArticleType => {
    const featuredMedia =
        // eslint-disable-next-line no-underscore-dangle
        r._embedded && r._embedded['wp:featuredmedia'] ? r._embedded['wp:featuredmedia'][0] : null;
    const terms =
        // eslint-disable-next-line no-underscore-dangle
        r._embedded && r._embedded['wp:term']
            ? // eslint-disable-next-line no-underscore-dangle
              r._embedded['wp:term']
            : null;

    const categories = terms ? terms[0]?.map((c: any) => c.name) || [] : [];
    const tags = terms ? terms[1]?.map((t: any) => t.name) || [] : [];

    let urlPath;
    switch (r.type) {
        case 'webinars':
            urlPath = 'webinar';
            break;
        case 'events':
            urlPath = 'event';
            break;
        default:
            urlPath = 'news';
            break;
    }

    const excerpt = r.excerpt?.rendered ?? r.excerpt;
    const { slug } = r;

    return {
        slug,
        id: r.id,
        permalink: `/${urlPath}/${slug}`,
        title: decodeEntities(r.title?.rendered || ''),
        type: r.type,
        typeLabel: r.type,
        isSticky: r.sticky ?? false,
        imageUrl: featuredMedia?.source_url || '',
        thumbnail: {
            url: featuredMedia?.source_url || '',
            dimensions: {
                width: featuredMedia?.media_details?.width || 0,
                height: featuredMedia?.media_details?.height || 0,
            },
        },
        publishedAt: r.date || '',
        publishedAtTimestamp: r.date ? new Date(r.date).getTime() / 1000 : 0,
        excerpt: decodeEntities(stripHtmlTags(excerpt ?? '')),
        content: r.content?.rendered || r.content,
        primaryCategory: categories.length > 0 ? categories[0] : '',
        categories,
        primaryTag: tags.length > 0 ? tags[0] : '',
        tags,
        customFields: r.acf || null,
        meta: r.yoast_head_json || null,
        authors: r.authors
            ? r.authors
                  .filter((author: any) => author.display_name && author.user_id)
                  .map((author: any) => ({
                      title: author.display_name || '',
                      id: author.user_id || '',
                      slug: author.slug || '',
                      image_url: author.image_url || '',
                  }))
            : [],
    };
};

export default mapWpPost;
